export enum DurationType {
  WITHIN_MONTH = 'WITHIN_MONTH',
  MONTH_PERIOD = 'MONTH_PERIOD',
}

export enum RiskChance {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum RiskOtherCategoryCodes {
  OTHER_STRATEGIC_ID = 45,
  OTHER_OPERATIONAL_ID = 70,
  OTHER_COMPLIANCE_ID = 78,
  OTHER_FINANCIAL_ID = 86,
}
